import { emailFields, requiredFields, validate } from 'utils/forms';

export default validate(
  emailFields('email'),
  requiredFields('email', 'password'),
);
